<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="loginUserPermission.indexOf('user_access') > -1">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">User List</div>
                        <!-- <router-link class="themebutton" v-bind:to="{name: 'AddUser'}">
                            <span>Add User</span>
                        </router-link> -->
                    </div>
                <vue-good-table
                    ref="UserList"
                    mode="remote"
                    title="Users List"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'Clear',
                    }"
                    
                    :search-options="{
                    enabled: false,
                    }">
                    <!-- <template v-if="user_role == 1"> -->
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <!--class="btn btn-xs btn-primary"-->
                                <div v-if="props.column.field == 'action'" class="table-action">
                                    <router-link title='Edit User' class="btn edit-btn-vvg waves-effect pull-left" v-bind:to="{name: 'UpdateUser',params:{id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                    <template v-if="props.row.is_active == 1">
                                        <button class="btn edit-btn-vvg waves-effect pull-left" v-on:click.prevent="activeOrInactiveState(props.row.id, 'inactive')">
                                            <i title="make inactive" class="fa fa-eye-slash" aria-hidden="true"></i>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button class="btn edit-btn-vvg waves-effect pull-left" v-on:click.prevent="activeOrInactiveState(props.row.id, 'active')">
                                            <i title="make active" class="fa fa-eye" aria-hidden="true"></i>
                                        </button>
                                    </template>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                    <!-- </template> -->
                    <div slot="selected-row-actions">
                        <template>
                            <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState(0, 'inactive')" class="btn btn-success waves-effect row-deactivate-btn">Deactivate</button>
                            <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState(0, 'active')" class="btn btn-success waves-effect row-activate-btn">Activate</button>
                        </template>
                    </div>
                </vue-good-table>   
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from "../../components/event-bus";
    import moment from 'moment';
    import timezone from 'moment-timezone';
    Vue.component("app-footer", Footer);
    Vue.use(VueGoodTable);
    var self;
    export default {
        name: 'CommonPage',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                loginUserPermission: ['user_access'],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Username',
                        field: 'username',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Username", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Emp Id',
                        field: 'emp_id',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Dayforce Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact No',
                        field: 'contact_no',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            // placeholder: "Contact No",
                            enabled: true, // enable filter for this column
                            placeholder: "Contact No", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created At',
                        field: 'created_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            // placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '108px',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                },
            }
        },
        watch: {
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.menuslug = "user-access";
            self.getRole();
            self.loadUser();
        },
        methods: {
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadUser();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadUser();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('site_name');
                    field: ('updated_at');
                    field: ('created_at');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.site_name || filters.updated_at || filters.created_at) {
                    self.loadUser();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['LocationList'].selectedRows).length;
                /* console.log(self.selectedRows); */
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadUser();
            },
            loadUser() {
                self.firstLoad = 1;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    tz: moment.tz.guess(),
                };
                self.showLoader();
                HTTP.post("listusers", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });

            },
            activeOrInactiveState(id, state) {

                var use = [];
                if(id == 0) {
                    var data = this.$refs['UserList'].selectedRows;
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['UserList'].selectedRows[i].id)
                    }

                }
                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to '+ state + ' User(s)!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {

                        var fields = {
                            id: (id != 0) ? id : use,
                            state: state,
                            flag: (id != 0) ? 'oneByOne' : 'all'
                        };

                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                        };
                        
                        self.showLoader();
                        HTTP.post("activeorinactiveusers", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadUser();
                                    if(response.data.content > 0) {
                                        //alert(response.data.content + " User has been already " + txtValue);
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (error) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                });

            }
        },
    };
    EventBus.$on('roleAndPermissions', function (isLogin, id, name, system_year, loginUserPermission) {
        if (typeof (self) != "undefined") {
            self.loginUserPermission = [];
            /* self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.roleName = name;
            self.system_year = system_year; */
            self.loginUserPermission = loginUserPermission;
        }
    });
</script>
<style scoped>
    .vgt-wrap {
        position: unset !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/UserManagement/ListUsers.vue